import { call, put, select, takeLatest } from "redux-saga/effects";
import { getWorkflowAnalyticsApi } from "../../../api/apiLists/workflow";
import {
  fetchWorkflowAnalyticsFailure,
  fetchWorkflowAnalyticsRequest,
  fetchWorkflowAnalyticsStart,
  fetchWorkflowAnalyticsSuccess
} from "../../slices/workflow";
import { callWorkflowApi, requireWhatsAppModuleAccess } from "./workflowSagaHelper";

function analyticsParamsMatch(cached, workflowId, version, month) {
  return (
    cached.lastParams.workflowId === workflowId &&
    cached.lastParams.version === version &&
    cached.lastParams.month === month
  );
}

function* handleFetchWorkflowAnalytics(action) {
  if (!(yield call(requireWhatsAppModuleAccess))) return;

  const { workflowId, version, month } = action.payload;
  const cached = yield select((state) => state.workflowAnalytics);

  if (cached.analytics && analyticsParamsMatch(cached, workflowId, version, month)) {
    return;
  }

  try {
    yield put(fetchWorkflowAnalyticsStart());

    const res = yield callWorkflowApi(getWorkflowAnalyticsApi, {
      operation: "GET_ANALYTICS",
      payload: { workflowId, version, month }
    });

    if (res.status) {
      yield put(fetchWorkflowAnalyticsSuccess({
        analytics: res.data.analytics,
        params: { workflowId, version, month }
      }));
      return;
    }

    yield put(fetchWorkflowAnalyticsFailure(res.errMsg));
  } catch (error) {
    yield put(fetchWorkflowAnalyticsFailure(error.message));
  }
}

export default function* workflowAnalyticsSaga() {
  yield takeLatest(fetchWorkflowAnalyticsRequest.type, handleFetchWorkflowAnalytics);
}
